import React from "react";
import { Profile } from "../types/quiz";
import { images } from "../data/images";
interface ResultProfileProps {
  name: string;
  primary: Profile;
  secondary: Profile | null;
  signals: string[];
  notes: string[];
  children?: React.ReactNode;
}
export function ResultProfile({
  name,
  primary,
  secondary,
  signals,
  notes,
  children
}: ResultProfileProps) {
  return <section aria-labelledby="perfil-title" data-id="element-309" data-mp="59bqffqacjip">
      <p className="text-base font-semibold text-olive-700" data-id="element-310" data-mp="5ad47ryork44">
        {name ? `${name}, tu perfil digestivo nocturno es:` : "Tu perfil digestivo nocturno es:"}
      </p>
      <h1 id="perfil-title" className="mt-2 font-serif text-3xl font-semibold leading-tight text-cocoa sm:text-[2.6rem]" data-id="element-311" data-mp="f77w3s0gem9f">
        “{primary.name}”
      </h1>
      {secondary && <p className="mt-4 text-lg text-cocoa" data-id="element-312" data-mp="1qmo9b0cvsw39">
          Tu perfil principal es <strong className="font-semibold" data-id="element-313" data-mp="1qktnzkxp71yn">“{primary.shortName}”</strong>, con un componente
          secundario de <strong className="font-semibold text-rose-600" data-id="element-314" data-mp="1lpo38pg17tc5">“{secondary.shortName}”</strong>.
        </p>}

      <div className="mt-8 grid gap-8 md:grid-cols-[1fr_1.1fr] md:items-start" data-id="element-315" data-mp="1exif1resqse1">
        <img src={images.nightDinner} alt="Cena caliente y casera servida de noche en la cocina" className="aspect-[4/3] w-full rounded-3xl object-cover" data-id="element-316" data-mp="1jsebd3r2g1wy" />
        <div data-id="element-317" data-mp="1trnccgkcmgst">
          <p className="text-lg leading-relaxed text-cocoa" data-id="element-318" data-mp="1tqc5u8ziquy0">{primary.result}</p>
          <h2 className="mt-6 text-sm font-semibold text-cocoa" data-id="element-319" data-mp="w67pbdkt4lnq">
            {signals.length > 0 ? "Señales que marcaste" : primary.listTitle}
          </h2>
          <ul className="mt-3 space-y-2" data-id="element-320" data-mp="162asmmreaqc9">
            {(signals.length > 0 ? signals : primary.list).map(item => <li key={item} className="flex items-start gap-2.5 text-base text-cocoa" data-id="element-321" data-mp="1aum1wg80zohh">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-coral-600" aria-hidden="true" data-id="element-322" data-mp="deyf1237psv3" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      {children}

      <div className="mt-10 grid gap-6 border-t border-blush-100 pt-8 md:grid-cols-2" data-id="element-323" data-mp="ab92v8zb0dsy">
        <div data-id="element-324" data-mp="5cftnsr1v8yl">
          <h2 className="font-serif text-xl font-semibold text-cocoa" data-id="element-325" data-mp="5cxvr60e8hef">{primary.sectionTitle}</h2>
          <p className="mt-2 text-base leading-relaxed text-cocoa-soft" data-id="element-326" data-mp="k1u12vb2fgbc">{primary.sectionText}</p>
        </div>
        {signals.length > 0 && <div data-id="element-327" data-mp="3nj3wtd2jhm1m">
            <h2 className="font-serif text-xl font-semibold text-cocoa" data-id="element-328" data-mp="3nikcxqtbwnky">{primary.listTitle}</h2>
            <p className="mt-2 text-base leading-relaxed text-cocoa-soft" data-id="element-329" data-mp="3ikisp2k62i7w">{primary.list.join(" · ")}</p>
          </div>}
      </div>

      {primary.keyPhrase && <p className="mt-8 rounded-2xl bg-blush-50 px-6 py-5 font-serif text-xl italic leading-snug text-rose-700 sm:text-2xl" data-id="element-330" data-mp="19j4tkax2gm7">
          {primary.keyPhrase}
        </p>}

      {notes.length > 0 && <div className="mt-6 space-y-3" data-id="element-331" data-mp="17ry3izcipa0r">
          {notes.map(n => <p key={n} className="border-l-2 border-olive-600 pl-4 text-base leading-relaxed text-cocoa" data-id="element-332" data-mp="17u269dyok2zg">
              {n}
            </p>)}
        </div>}
    </section>;
}